export const APP_GET_MAIN_MENU = "APP_GET_MAIN_MENU";
export const APP_GET_DEFAULT_LANGUAGE = 'APP_GET_DEFAULT_LANGUAGE';
export const APP_CHANGE_LANGUAGE = 'APP_CHANGE_LANGUAGE';

export const DEVICE_RESET_STATE = 'DEVICE_RESET_STATE';
export const DEVICE_REGISTER_DOING = 'DEVICE_REGISTER_DOING';
export const DEVICE_REGISTER_DONE = 'DEVICE_REGISTER_DONE';

export const DEVICE_DETAIL_SEARCH_DOING = 'DEVICE_DETAIL_SEARCH_DOING';
export const DEVICE_DETAIL_SEARCH_DONE = 'DEVICE_DETAIL_SEARCH_DONE';

// Attachment Actions
export const ATTACHMENT_LOADING = 'ATTACHMENT_LOADING';
export const ATTACHMENT_SEARCH = 'ATTACHMENT_SEARCH';

export const DEVICE_ECG_DATA_SEARCH_DONE = 'DEVICE_ECG_DATA_SEARCH_DONE';

export const USER_LIST_SEARCH_DOING = 'USER_LIST_SEARCH_DOING';
export const USER_LIST_SEARCH_DONE = 'USER_LIST_SEARCH_DONE';

export const USER_DETAIL_SEARCH_DOING = 'USER_DETAIL_SEARCH_DOING';
export const USER_DETAIL_SEARCH_DONE = 'USER_DETAIL_SEARCH_DONE';
export const APP_REFRESH_USER_INFO = 'APP_REFRESH_USER_INFO'
